
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      fileList: [] as any[],
      dialogVisible: false,
      dialogImageUrl: "",
    };
  },
  methods: {
    handleRemove(file: any, fileList: any) {
      this.fileList = fileList;
    },
    handlePreview(file: any) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    Uploaded(response: any, file: any) {
      if (file.status == "success") {
        file.url = response.image;
        this.fileList.push(file);
        this.$emit("Uploaded", file.url);
      } else {
        throw response.RetMsg;
      }
    },
    GetPics() {
      return this.fileList;
    },
    initPic(pic: string, name: string) {
      this.fileList.push({
        url: pic,
        name: name,
      });
    },
    clearPic() {
      this.fileList = [];
    },
  },
});
